module.exports = __webpack_public_path__ + "img/DS1621+.07046dea.png";